import { render, staticRenderFns } from "./ProductsPlaceholder.vue?vue&type=template&id=f446b588&scoped=true"
import script from "./ProductsPlaceholder.vue?vue&type=script&lang=js"
export * from "./ProductsPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./ProductsPlaceholder.vue?vue&type=style&index=0&id=f446b588&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f446b588",
  null
  
)

export default component.exports